export const enum CookieNames {
  Championship = 'championship',
  CognitoBaseCookie = 'CognitoIdentityServiceProvider',
  CognitoGroups = 'cognito:groups',
  PPcontactIdentifier = 'custom:PPContactIdentifier',
  IdToken = 'idToken',
  Roles = 'roles',
}
